/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ErrorService } from '../../services/error.service';
import { AdminNBClassifierService } from '../../services/admin/admin-nbclassifier.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, EmailType, Language } from '../../global/constants';

import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-admin-nb-classifier',
  templateUrl: './admin-nb-classifier.component.html'
})
export class AdminNbClassifierComponent implements OnInit {

  loadingPage = true;
  editTrainingDialogRef: BsModalRef;
  currentType: EmailType;
  currentLanguage: Language;
  training: any[] = [];
  wordmap: any = {};
  nbTypes: EmailType[] = [];

  currentTraining: any = {
    _id: null,
    training: '',
    lang: 'en'
  };

  typeFilter: string = 'general';
  languageFilter: string = 'en';

  showWordmap: boolean = false;
  topWord: number = 0;
  topStopword: number = 0;

  dialogTitle = '';

  constructor(private errorService: ErrorService,
              private modalService: BsModalService,
              private adminNBClassifierService: AdminNBClassifierService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) {
  }

  ngOnInit() {
    this.nbTypes = this.getNbTypes();
    this.currentType = this.nbTypes[1];
    this.currentLanguage = this.constants.languages[0];
    this.refreshTraining();
  }

  getNbTypes() {
    let results = []
    this.constants.emailTypes.forEach((t:EmailType) => {
      if (t.nbType) {
        results.push(t);
      }
    });
    return results;
  }

  changeType() {
    this.currentType = this.getNbTypes().find((t:EmailType) => {
      return t.typeName == this.typeFilter;
    });
    this.refreshTraining();
  }

  changeLanguage() {
    this.currentLanguage = this.constants.languages.find((l:Language) => {
      return l.name == this.languageFilter;
    });
    this.refreshTraining();
  }

  editTraining(dialog, training: any = null) {
    let me = this;
    this.currentTraining.training = training ? training.content : '';
    this.currentTraining.lang = training ? training.language : this.languageFilter;
    this.dialogTitle = `Add ${this.currentType.display} training`;
    if (training) {
      this.dialogTitle = `Edit ${this.currentType.display} training`;
      this.currentTraining._id = training._id;
    }
    else {
      this.currentTraining._id = null;
    }

    this.editTrainingDialogRef = this.modalService.show(dialog, Object.assign({}, { class: 'modal-lg' }));
  }

  saveTraining() {
    this.editTrainingDialogRef.hide();
    if (this.currentTraining._id) {
      this.adminNBClassifierService.updateTraining(this.currentTraining._id, this.currentTraining.training, this.currentTraining.lang).subscribe(
        (result: any) => {
          this.globalMessageService.message('Updated training');
          this.refreshTraining();
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'admin-nb-classifier.component', 'editTraining.100');
        }
      )
    }
    else {
      this.adminNBClassifierService.newTraining(this.currentType.typeName, this.currentTraining.training, this.currentTraining.lang).subscribe(
        (result: any) => {
          this.globalMessageService.message('Added training');
          this.refreshTraining();
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'admin-nb-classifier.component', 'editTraining.200');
        }
      )
    }
  }

  delete(training: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this training: "${training.content}"`,
        confirm: function() {
          me.adminNBClassifierService.deleteTraining(training._id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Training was deleted');
              me.refreshTraining();
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'admin-nb-classifier.component', 'delete');
            });
        }
      }
    }));
  }

  addStopword(word: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to add this stopword: "${word.word}"`,
        confirm: function() {
          me.adminNBClassifierService.newStopword(word.word, me.languageFilter).subscribe(
            (result: any) => {
              me.globalMessageService.message('Stopword was added');
              me.refreshTraining();
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'admin-nb-classifier.component', 'addStopword');
            });
        }
      }
    }));
  }

  deleteStopword(word: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this stopword: "${word.word}"`,
        confirm: function() {
          me.adminNBClassifierService.deleteStopword(word.word, me.languageFilter).subscribe(
            (result: any) => {
              me.globalMessageService.message('Stopword was deleted');
              me.refreshTraining();
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'admin-nb-classifier.component', 'deleteStopword');
            });
        }
      }
    }));
  }

  clean() {
    this.currentTraining.training = this.currentTraining.training
                                  .replace(/['’]/g, '')
                                  .replace(/[@.,-\/#!?$%\^&\*;:{}=\-_`~()\<\>"|0-9]/g, ' ')
                                  .replace(/\s{2,}/g, ' ')
                                  .trim()
                                  .toLowerCase();
  }

  getWidth(count, total) {
    return (count/total*100).toString() + '%';
  }

  private refreshTraining() {
    this.loadingPage = true;
    this.topWord = 0;
    this.topStopword = 0;
    Observable.forkJoin(
      this.adminNBClassifierService.getNBTraining(this.currentType.typeName, this.languageFilter),
      this.adminNBClassifierService.getWordmap(this.currentType.typeName, this.languageFilter)
    ).subscribe(
      (result: any) => {
        this.training = result[0];
        this.wordmap = JSON.parse(result[1]);
        this.wordmap.words.forEach((wm) => {
          if (wm.stop_word && wm.count > this.topStopword) {
            this.topStopword = wm.count;
          }
          else if (!wm.stop_word && wm.count > this.topWord) {
            this.topWord = wm.count;
          }
        });
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-nb-classifier.component', 'refreshTraining.100');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-nb-classifier/admin-nb-classifier.component.ts